// DrinkingWater.jsx
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaHandHoldingHeart, FaTint, FaArrowRight, FaWater } from "react-icons/fa";
import water from "../Assests/water.png";
import "./Water.css";

const Water = () => {
  const navigation = useNavigate();
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const element = document.getElementById('water-section');
    if (element) observer.observe(element);

    return () => {
      if (element) observer.unobserve(element);
    };
  }, []);

  return (
    <div id="water-section" className="luxury-water-section">
      <Container fluid className="water-container">
        <Row className="align-items-center water-row">
          {/* Left Side - Water Decorative Line */}
          <Col lg={1} className="water-decoration-col">
            <div className="water-vertical-line">
              <div className="water-drops">
                <FaWater className="water-drop" />
                <FaWater className="water-drop delay-1" />
                <FaWater className="water-drop delay-2" />
              </div>
            </div>
          </Col>

          {/* Middle - Content */}
          <Col lg={6} md={12}>
            <div className={`water-content ${isVisible ? 'fade-in-up' : ''}`}>
              <div className="content-badge">
                <FaTint className="badge-icon" />
                <span>Clean Water Initiative</span>
              </div>
              
              <h2 className="water-title">
                {t("title4")}
                <span className="title-wave">💧</span>
              </h2>
              
              <div className="water-text-wrapper">
                <p className="water-description">
                  {t("about4")}
                </p>
              </div>

              <div className="water-stats">
                <div className="stat-item">
                  <span className="stat-number">5000+</span>
                  <span className="stat-label">Beneficiaries</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">50+</span>
                  <span className="stat-label">Villages</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">100%</span>
                  <span className="stat-label">Access</span>
                </div>
              </div>

              <div 
                className="luxury-donate-btn"
                onClick={() => navigation("/whydonation")}
              >
                <span>Donate Now</span>
                <FaArrowRight className="btn-icon" />
                <div className="btn-glow"></div>
              </div>
            </div>
          </Col>

          {/* Right Side - Image */}
          <Col lg={5} md={12}>
            <div className={`water-image-wrapper ${isVisible ? 'slide-in-right' : ''}`}>
              <div className="image-container">
                <img src={water} alt="Clean Water" className="water-main-image" />
                <div className="image-border-glow"></div>
                <div className="water-ripple"></div>
                <div className="water-ripple delay-1"></div>
                <div className="water-ripple delay-2"></div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Water;